import { CardLoader } from 'components/organisms'
import PaginationBar from 'components/organisms/pagination-bar/pagination-bar'
import withLoader from 'hocs/with-loader/with-loader'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'
import MarketingDiscountBatchItemTableRow from './marketing-discount-batch-item-table-row'

const proptypes = {
  tableProps          : PropTypes.object,
  discountBatchItems  : PropTypes.array,
  pagination          : PropTypes.object,
  isLoading           : PropTypes.bool,
  onClickCancelRemove : PropTypes.func,
  onPageChange        : PropTypes.func
}

const defaultProps = {
  tableProps          : {},
  discountBatchItems  : [],
  pagination          : {},
  isLoading           : true,
  onClickCancelRemove : () => {},
  onPageChange        : () => { }
}

const MarketingDiscountBatchItemTable = ({
  tableProps,
  discountBatchItems,
  pagination,
  isLoading,
  onClickCancelRemove,
  onPageChange
}) => {
  const totalColumns = 11
  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th scope="col">{ 'sku' }</th>
          <th scope="col">{ 'current selling price' }</th>
          <th scope="col">{ 'expected tl revenue' }</th>
          <th scope="col">{ 'expected seller revenue' }</th>
          <th scope="col">{ 'new selling price' }</th>
          <th scope="col">{ 'price before discount' }</th>
          <th scope="col">{ 'status' }</th>
          <th scope="col">{ 'code' }</th>
          <th scope="col">{ 'runs at' }</th>
          <th scope="col">{ 'expires at' }</th>
          <th scope="col">{ 'action' }</th>
        </tr>
      </thead>
      <tbody>
        {
          discountBatchItems.map((item) => (
            <MarketingDiscountBatchItemTableRow
              key={ `MarketingDiscountBatchItemTableRow-${item.id}` }
              handleClick={ () => onClickCancelRemove(item) }
              discountBatchItem={ item }
            />
          ))
        }

        {
          discountBatchItems.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Marketing Discount Batch found based on your filters.' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <div className='d-flex justify-content-between mt-3'>
        <PaginationBar
          onClickPage={ onPageChange }
          pagination={ pagination }
        />
      </div>
    </>
  )
}

MarketingDiscountBatchItemTable.propTypes    = proptypes
MarketingDiscountBatchItemTable.defaultProps = defaultProps

export default MarketingDiscountBatchItemTable
